import * as Yup from "yup";

export const initialValues = {
  legal_first_name: "",
  legal_last_name: "",
  profile_name: "",
  phone_number: "",
  email: "",
  title: "",
  url: "",
  upload_date: "",
  proof_media: "",
  copyright_number: "",
  signature: "",
  wheel: null,
  segment: null,
  street_address: "",
  apartment_number: "",
  city: "",
  state: "",
  zip_code: "",
  country: "",
  statements: {
    goodFaith: false,
    declaration: false,
  },
  signature_consent: false,
};

export const validationSchema = Yup.object().shape({
  legal_first_name: Yup.string().required("First name is required"),
  legal_last_name: Yup.string().required("Last name is required"),
  profile_name: Yup.string().required("Profile name is required"),
  phone_number: Yup.string().required("Phone number is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  title: Yup.string().required("Title is required"),
  url: Yup.string().required("URL is required"),
  upload_date: Yup.string()
    .required("Upload date is required")
    .test("is-valid-date", "Enter a valid date (YYYY-MM-DD)", function (value) {
      if (!value) return false;

      // Check if it matches YYYY-MM-DD format
      const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateFormatRegex.test(value)) return false;

      // Validate that it's a real date
      const date = new Date(value);
      return !isNaN(date.getTime());
    }),
  proof_media: Yup.mixed().nullable(),
  copyright_number: Yup.string(),
  signature: Yup.string().required("Signature is required"),
  wheel: Yup.number()
    .typeError("Wheel must be a number")
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .required("Wheel is required"),
  segment: Yup.number()
    .typeError("Segment must be a number")
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .required("Segment is required"),
  street_address: Yup.string().required("Street address is required"),
  apartment_number: Yup.string(),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  zip_code: Yup.string().required("ZIP code is required"),
  country: Yup.string().required("Country is required"),
  statements: Yup.object().shape({
    goodFaith: Yup.boolean()
      .oneOf([true], "You must agree to this statement")
      .required("You must agree to this statement"),
    declaration: Yup.boolean()
      .oneOf([true], "You must agree to this statement")
      .required("You must agree to this statement"),
  }),
  signature_consent: Yup.boolean()
    .oneOf([true], "You must agree to use your typed name as signature")
    .required("You must agree to use your typed name as signature"),
});
